// App.jsx
import React from 'react';
import { Fragment } from "react";
import Header from './components/Header';
import NavBar from './components/NavBar';
import Banner from './components/Banner';
import AcessosRapidos from './components/AcessosRapidos';
import Noticias from './components/Noticias'; // comente se ainda não existir
import ChatBot from './components/ChatBot';
import Footer from './components/Footer';



function App() {
  return (
    <Fragment>
      <div className="font-sans text-gray-800">
        <Header />
        <NavBar />
        <Banner />
        <AcessosRapidos />
        <Noticias />
        {/* <ChatBot /> */}
        <Footer />
      </div>
    </Fragment>
  );
}

export default App;
